import React, { useEffect, useState } from 'react';
import './index.css';
import { NavLink } from 'react-router-dom';
import logoBlack from '../../images/navbar/logo-black.png';
import 'bootstrap/dist/css/bootstrap.min.css';
import 'bootstrap/dist/js/bootstrap.bundle.min.js';
import { jwtDecode } from 'jwt-decode';
import NavbarLogout from './navbar-logout';

const Navbar = ({ handleLoginClick, handleSignupClick, prefix, }) =>
{
    const [prefixVal, setPrefixVal] = useState('');
    const [username, setUsername] = useState('');

    const handleButtonClick = (action) =>
    {
        let url;
        if (action === 'register')
        {
            url = prefixVal === 'Biz ' ? '/register-business-user' : '/register-home-user';
        } else if (action === 'login')
        {
            url = prefixVal === 'Biz ' ? '/login' : '/login';
        }
        setPrefixVal('');
        window.location.href = url;
    };

    useEffect(() =>
    {
        setPrefixVal(prefix);
        const token = localStorage.getItem('token');
        if (token)
        {
            const decodeToken = jwtDecode(token);
            setUsername(decodeToken.UserName);
        }
    }, [prefix]);

    return (
        <div>
            <header className="bsp-header">
                <nav className="navbar navbar-expand-sm navbar-dark">
                    <div className="container">
                        <a className="navbar-brand" href="/">
                            <img src={logoBlack} alt="Logo" />
                        </a>
                        <button className="navbar-toggler" type="button" data-bs-toggle="collapse" data-bs-target="#mynavbar">
                            <span></span>
                            <span></span>
                            <span></span>
                        </button>
                        <div className="collapse navbar-collapse" id="mynavbar">
                            <ul className="navbar-nav m-auto">
                                <li className="nav-item">
                                    <NavLink className="nav-link" to="/">Home Owner</NavLink>
                                </li>
                                <li className="nav-item">
                                    <NavLink className="nav-link" to="/business-home">Building Professionals</NavLink>
                                </li>
                                <li className="nav-item">
                                    <NavLink className="nav-link" to="/education-home">Education Hub</NavLink>
                                </li>

                                <li className="nav-item">
                                    <a 
                                        className="nav-link" 
                                        href="https://social.buildstart.au" 
                                        target="_blank" 
                                        rel="noopener noreferrer"
                                    >
                                        Social Platform
                                    </a>
                                </li>

                            </ul>
                            {username ? (
                                <NavbarLogout UserName={username} />
                            ) : (
                                <div className="d-flex header-btns">
                                    <button
                                        className="btn login-btn transition"
                                        type="button"
                                        onClick={() => handleButtonClick('login')}
                                    >
                                        {prefix}Login
                                    </button>
                                    <button
                                        className="btn register-btn transition"
                                        type="button"
                                        onClick={() => handleButtonClick('register')}
                                    >
                                        {prefix}Register
                                    </button>
                                </div>
                            )}
                        </div>
                    </div>
                </nav>
            </header>
        </div>
    );
};

export default Navbar;